module.exports = __webpack_public_path__ + "img/e_card.bad9c163.png";